import axios from 'axios';
import * as React from 'react';
import { requestUpdateList } from '../asyncHelpers/listsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { UpdateListRequest } from '../sic-lib/types/Lists';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncModifyList
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestUpdateList HTTP request
 */
export default function useAsyncModifyList() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncModifyList = async (list: UpdateListRequest): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestUpdateList(list, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while modifying list');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncModifyList,
    };
}
